import { toUpper } from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import Icon from '../../../components/icon';
import {Column, Row} from '../../../components/layout';
import {colors} from '../../../util/colors';
import {Icons} from '../../../util/icons';
import {strings} from '../../../util/strings';
import {createGUID} from '../../../util/utility';
import {UtilizationItem} from '../UtilizationHistory';
import UtilizationListItem from './UtilizationListItem';

export interface UtilizationListProps {
  selectedItem(filterItem: UtilizationItem): void;
  utilizationItems?: UtilizationItem[];
  labels: typeof strings.pt.refund;
  labelsHistory: typeof strings.pt.insuranceHistory;
}

function UtilizationList({
  utilizationItems,
  selectedItem,
  labels,
  labelsHistory,
}: UtilizationListProps) {
  return (
    /*if collection is empty, show message 'there are none'*/
    utilizationItems?.length === 0 ? (
      <Column className="reimbursement-history-no-reimbursementsyet">
        <Icon
          className="reimbursement-history-filter-icon"
          name={Icons.ALERT_PROBLEM}
          color={colors.lightGrey}
          width="40"
          height="40"
          changeViewbox 
          viewBox={'0 0 24 24'}
        />
        <h6 style={{color: colors.lightGrey, marginTop: 20}}>
          {labelsHistory.insuranceHistory_noResults}
        </h6>
      </Column>
    ) : (
      <>
        <Row>
          <Column className="reimbursement-history-header">{toUpper(labelsHistory.medicalActIn)}</Column>
        </Row>
        <div className="reimbursement-history-declarationlist-line"></div>
        {utilizationItems?.map((element: UtilizationItem) => (
          <div
            key={createGUID()}
            onClick={() => selectedItem(element)}
            style={{cursor: 'pointer'}}>  
            <UtilizationListItem
              key={createGUID()}
              utilizationItem={element}></UtilizationListItem>
          </div>
        ))}
      </>
    )
  );
}

const mapStateToProps = ({strings}: any) => ({
  labels: strings.value.pt.refund,
  labelsHistory: strings.value.pt.insuranceHistory,
});

export default compose(connect(mapStateToProps)(UtilizationList));
